<template>
  <div>
    <div class="advanceParent">
      <app-history
        @clicked="showJarimehDialog()"
        title="محاسبه جریمه"
        :fixsize="true"
      />
      <app-history
        @clicked="showDialog = true"
        class="advancedSearch"
        title="جستجوی پیشرفته"
      />
      <export-excel
        style="float: left"
        :fetch="GetDataForExcel"
        :fields="excelHeaders"
        worksheet="My Worksheet"
        name="گزارش سفارشات.xls"
      >
        <app-history class="advancedSearch" title="خروجی اکسل" />
      </export-excel>
    </div>
    <div>
      <v-data-table
        :items="orders"
        :headers="ordersHeaders"
        class="elevation-1 rounded"
        :server-items-length="totalCount"
        :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
          itemsPerPageOptions: [10],
        }"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
        @pagination="doPage"
      >
        <template v-slot:[`item.foodPrice`]="{ item }">
          {{ Number(item.foodPrice).toLocaleString() }}
        </template>

        <template v-slot:[`item.sabtDate`]="{ item }">
          {{ convertDate(item.sabtDate) }}
        </template>
        <template v-slot:[`item.deliveryDate`]="{ item }">
          {{
            item.deliveryDate != null ? convertDate(item.deliveryDate) : "ندارد"
          }}
        </template>
        <template v-slot:[`item.kprice`]="{ item }">
          {{ GetKprice(item.kprice) }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ GetStatus(item.status) }}
          <template v-if="item.status == 0">
            <span style="margin:0 3px">/</span>
            <v-btn
              color="red white--text"
              class="dialogButton"
              rounded
              @click="cancelRequest(item.id)"
              >لغو</v-btn
            >
          </template>
        </template>
        <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }"
          >از {{ pageStart }} تا {{ pageStop }}</template
        >
      </v-data-table>
    </div>
    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center" v-if="selectedFardId == 0">
        <v-col class="d-flex" cols="12" sm="4">
          {{ "انتخاب فرد" }}
        </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="currentCode"
            maxlength="10"
            :oninput="onInput"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> </v-col>
        <v-col class="d-flex fardName" cols="12" sm="8">
          {{ currentFard }}
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ شروع: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="StartDate"
            @click="onClickDate(1)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ پایان: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="EndDate"
            @click="onClickDate(2)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="GetAllOrders"
          :disabled="apiRunning"
        >
          جستجو
        </v-btn>
        <v-btn
          color="red white--text"
          class="dialogButton"
          rounded
          @click="clearFilter"
          :disabled="apiRunning"
        >
          پاک کردن
        </v-btn>
        <v-btn class="dialogButton" rounded @click="showDialog = false">
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <date-picker
      ref="datepicker1"
      v-model="StartDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput1"
      @change="onChangeDate($event, 1)"
    ></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker
      ref="datepicker2"
      v-model="EndDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput2"
      @change="onChangeDate($event, 2)"
    ></date-picker>
    <input id="fileInput2" ref="fileInput2" />
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetAllOrders, CalculateJarimeh } from "@/api/orders";
import { FindUserByCode } from "@/api/user";
import moment from "moment-jalaali";
import { Cancel } from "@/api/orders";

export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      orders: [],

      currentCode: "",
      fardId: 0,
      currentFard: "",
      StartDate: "",
      EndDate: "",
      totalCount: 0,
      dialogType: 0, // 1= jarimeh 2 = cancel
      ordersHeaders: [
        {
          text: "نام فرد",
          value: "fardName",
          width: "15%",
          sortable: false,
        },

        {
          text: "کد ملی",
          value: "nationalCode",
          width: "10%",
        },
        {
          text: "وعده",
          value: "mealName",
          width: "5%",
        },
        {
          text: "غذا",
          value: "foodName",
          width: "10%",
        },
        {
          text: "قیمت (ریال)",
          value: "foodPrice",
          width: "5%",
        },
        {
          text: "تعرفه",
          value: "kprice",
          width: "5%",
        },
        {
          text: "تعداد سفارش",
          value: "numberOrder",
          width: "5%",
        },
        {
          text: "تاریخ سفارش",
          value: "sabtDate",
          width: "10%",
        },
        {
          text: "تاریخ وعده",
          value: "tarikh",
          width: "10%",
        },
        {
          text: "تاریخ تحویل",
          value: "deliveryDate",
          width: "10%",
        },
        {
          text: "مکان تحویل",
          value: "deliveryPlaceName",
          width: "10%",
        },
        {
          text: "وضعیت",
          value: "status",
          width: "5%",
        },
        {
          text: "",
          value: "actions",
          width: "%1",
        },
      ],
      excelHeaders: {
        "نام فرد": "fardName",
        "کد ملی": "nationalCode",
        غذا: "foodName",
        وعده: "mealName",
        "قیمت (ریال)": {
          field: "foodPrice",
          callback: (value) => {
            return Number(value).toLocaleString();
          },
        },
        تعرفه: {
          field: "kprice",
          callback: (value) => {
            return this.GetKprice(value);
          },
        },
        "تعداد سفارش": "numberOrder",
        "تاریخ سفارش": {
          field: "sabtDate",
          callback: (value) => {
            return this.convertDate(value);
          },
        },
        "تاریخ وعده": "tarikh",
        "تاریخ تحویل": {
          field: "deliveryDate",
          callback: (value) => {
            return value ? this.convertDate(value) : "ندارد";
          },
        },
        "مکان تحویل": "deliveryPlaceName",
        وضعیت: {
          field: "status",
          callback: (value) => {
            return this.GetStatus(value);
          },
        },
      },
    };
  },
  created() {
    this.fardId = this.selectedFardId;
    if (this.currentBranch) this.GetAllOrders();
  },
  computed: {
    selectedFardId() {
      return this.$store.getters.selectedFard.fardId;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
  },
  watch: {
    currentCode(value) {
      if (value.length == 10 || value.length == 12) {
        this.FindUser();
      } else {
        this.currentFard = "";
        this.fardId = 0;
      }
    },
  },
  methods: {
    doPage($event) {
      this.GetAllOrders(($event.page - 1) * 10);
    },
    onChangeDate($event, input) {
      if (input == 1) {
        this.StartDate = $event.format("jYYYY/jMM/jDD");
      } else {
        this.EndDate = $event.format("jYYYY/jMM/jDD");
      }
    },
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    clearFilter() {
      if (this.selectedFardId == 0) {
        this.fardId = 0;
        this.currentFard = "";
        this.currentCode = "";
      }

      this.StartDate = "";
      this.EndDate = "";
      this.GetAllOrders();
    },
    async GetDataForExcel() {
      const response = await GetBranchPayments(
        this.currentBranch.id,
        this.fardId,
        this.StartDate,
        this.EndDate,
        -1
      );
      return response.data.items;
    },
    async GetDataForExcel() {
      const response = await GetAllOrders(
        this.currentBranch.id,

        this.fardId,
        this.StartDate,
        this.EndDate,
        -1
      );
      return response.data.items;
    },
    GetAllOrders(skip) {
      if (isNaN(skip)) skip = 0;
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetAllOrders(
          this.currentBranch.id,

          this.fardId,
          this.StartDate,
          this.EndDate,
          skip
        )
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.orders = response.data.items;
            this.totalCount = response.data.count;
            this.$store.commit("SET_TABLE_TEXT", false);
            this.showDialog = false;

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    cancelRequest(orderid) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", orderid);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به لغو این سفارش هستید؟"
      );
      this.dialogType = 2;
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    convertDate(date) {
      return moment(date).format("HH:mm jYYYY/jMM/jDD");
    },
    GetKprice(kprice) {
      switch (kprice) {
        case 1:
          return "طلبه";
        case 2:
          return "استاد";
        case 3:
          return "پرسنل";
        case 4:
          return "آزاد";
        case 5:
          return "سایر";
      }
    },
    GetStatus(status) {
      switch (status) {
        case 0:
          return "رزرو";
        case 1:
          return "تحویل";
        case 3:
          return "جریمه";
      }
    },
    FindUser() {
      return new Promise((resolve, reject) => {
        FindUserByCode(this.currentCode)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            const data = response.data.data;
            this.fardId = data.fardID;
            this.currentFard =
              data.fardID != 0
                ? data.name + " " + data.family
                : "موردی یافت نشد.";

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    showJarimehDialog() {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", 1);

      var endDate = moment()
        .add("days")
        .format("HH:mm jYYYY/jMM/jDD");

      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به اعمال جریمه تا " + endDate + " هستید؟"
      );
      this.dialogType = 1;
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    onCloseDialog(index) {
      if (index != -1) {
        if (this.dialogType == 1) {
          //this.$store.commit("SET_API_RUNNING", true);
          CalculateJarimeh(this.currentBranch.id)
            .then((response) => {
              const data = response.data;
              this.$store.commit("SET_SNACKBAR_TEXT", data.message);
              this.$store.commit("SET_API_RUNNING", false);
            })
            .catch((error) => {
              console.log(error);
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
        } else if (this.dialogType == 2) {
          Cancel(index)
            .then((response) => {
              const data = response.data;
              this.$store.commit("SET_SNACKBAR_TEXT", data.message);

              if (data.success) {
                this.GetAllOrders();
              }
            })

            .catch((_) => {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
        }
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
<style>
.text-start.cellLtr {
  direction: ltr;
  text-align: end !important;
}

.textLtr input {
  direction: ltr;
  text-align: right;
}

.filterButton {
  width: 100%;
}
</style>
